var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MaterialIcons',{staticClass:"iconName"},[_vm._v("\n  "+_vm._s(_vm.iconName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }